// validate
import './jquery-validation/jquery.validate';
import './jquery-validation/additional-methods';


$(function() {
	
	// custom methods

	$.validator.addMethod( "passwordMin12", function( value, element, params ) {
		return this.optional( element ) || value.length >= 12;
	}, $.validator.format("Password must have at least 12 characters"));

	$.validator.addMethod( "passwordUpper", function( value, element, params ) {
		return this.optional( element ) || hasUppercase(value);
	}, $.validator.format("Password must have at least 1 uppercase letter"));

	$.validator.addMethod( "passwordLower", function( value, element, params ) {
		return this.optional( element ) || hasLowercase(value);
	}, $.validator.format("Password must have at least 1 lowercase letter"));

	$.validator.addMethod( "passwordNumber", function( value, element, params ) {
		return this.optional( element ) || hasNumber(value);
	}, $.validator.format("Password must have at least 1 number"));

	$.validator.addMethod( "passwordChar", function( value, element, params ) {
		return this.optional( element ) || hasSpecialChar(value);
	}, $.validator.format("Password must have at least 1 special character from !@#$%^&*()-=?~`_"));

	$.validator.addMethod( "dateYmd", function( value, element, params ) {
		return this.optional( element ) || isValidDate(value);
	}, $.validator.format("The date does not match the format yyyy-mm-dd"));

	$.validator.addMethod( "dateYm", function( value, element, params ) {
		return this.optional( element ) || isValidDate(value + '-01');
	}, $.validator.format("The date does not match the format yyyy-mm"));

    $.validator.addMethod("summernote", function (value, element, params) {
		return this.optional( element ) || !(value && value == '<p><br></p>');
	}, $.validator.format("This field is required."));

    $.validator.addMethod("greaterThan", 
    function(value, element, params) {

        if (!/Invalid|NaN/.test(new Date(value))) {
            return new Date(value) >= new Date($(params).val());
        }

        return isNaN(value) && isNaN($(params).val()) 
            || (Number(value) > Number($(params).val())); 
    },'Must be greater than(or same as) start date.'); //'Must be greater than {0}.'

    //MSCD table validations
    $.validator.addMethod("collaboratorCheck", function(value, elem, param) {
        let check1 =$('input[name="project_collaborators"]:checked').attr('radiotext');
        let tableCount = parseInt($('#collaborators_count').val());
        if(check1 == "yes" && tableCount <= 0) return false;
        else return true;
    },"");

    $.validator.addMethod("signatoriesCheck", function(value, elem, param) {
        let check1 =$('input[name="has_bank_account"]:checked').attr('radiotext');
        let tableCount =$('#signatories_count').val();
        if(check1 == "yes" && tableCount <= 0) return false;
        else return true;
    },"");

    $.validator.addMethod("supportCheck", function(value, elem, param) {
        let check1 =$('input[name="has_applied_for_funding_elsewhere"]:checked').attr('radiotext');
        let tableCount =$('#other_support_count').val();
        if(check1 == "yes" && tableCount <= 0) return false;
        else return true;
    },"");

    $.validator.addMethod("approvalCheck", function(value, elem, param) {
        let check1 =$('input[name="require_approvals_for_project"]:checked').attr('radiotext');
        let tableCount =$('#approvals_count').val();
        if(check1 == "yes" && tableCount <= 0) return false;
        else return true;
    },"");

    $.validator.addMethod("ageRangeCheck", function(value, elem, param) {
        let check1 =parseInt($('#ageRangStart').val());
        let check2 = $('#ageRangEnd').val() ? parseInt($('#ageRangEnd').val()) : 0;
        if(check2 == 0) return true;
        return check1 < check2;
    },"Please enter a value more than start");

    $.validator.addMethod("sponsorCheck", function(value, elem, param) {
        let check1 =$('input[name="has_received_funding_mscd"]:checked').attr('radiotext');
        let check2 =$('input[name="received_previous_assistance_state"]:checked').attr('radiotext');
        let tableCount =$('#previous_sponsorship_count').val();
        
        if((check1 == "yes" || check2 == "yes") && tableCount <= 0) return false;
        else return true;
    },"");

    $.validator.addMethod("trinidad", function(value, elem, param) {
        if ($('#nationality').val() != "224") {
            return false;
        } else return true;
    }, $.validator.format("Applications are only accepted from Trinidad and Tobago nationals."));

    $.validator.addMethod("oneOfTwoFieldsFilled", function(value, element, params) {
        var field1Value = $("#national_id").val();
        var field2Value = $("#passport").val();
        return (field1Value !== "" || field2Value !== "");
    }, "Please fill at least one of the fields.");

    //end MSCD table validation
    
});
    
function passwordValidate() {
    var password = $('[name="password"]');
    $('#err-password').html("");
    password.removeClass('is-invalid');
    var error = '';
    var chk = true;
    
    if (password.val().length < 12) {
        error += 'Password must have at least 12 characters';
    }
    if (!hasUppercase(password.val())) {
        err = 'Password must have at least 1 uppercase letter';
        error += error? '<br>'+ err : err;
    }
    if (!hasLowercase(password.val())) {
        err = 'Password must have at least 1 lowercase letter';
        error += error? '<br>'+ err : err;
    }
    if (!hasNumber(password.val())) {
        err = 'Password must have at least 1 number';
        error += error? '<br>'+ err : err;
    }
    if (!hasSpecialChar(password.val())) {
        err = 'Password must have at least 1 special character from !@#$%^&*()-=?~`_';
        error += error? '<br>'+ err : err;
    }
    if (error) {
        $('#err-password').html(error);
        password.addClass('is-invalid');
        chk = false;
    }
    
    return chk;
}

function imgError(image) {
    image.onerror = "";
    image.src = "{{asset('images/blank-img.png')}}";
    return true;
}

function avatarError(image) {
    image.onerror = "";
    image.src = "{{asset('images/avatar.png')}}";
    return true;
}

function nameFormat(string) {
    var regex = /^[a-zA-Z0-9-'! ]+$/;
    return string.match(regex) != null;
}

function hasUppercase(string) {
    var regex= new RegExp('[A-Z]');
    return string.match(regex) != null;
}

function hasLowercase(string) {
    var regex= new RegExp('[a-z]');
    return string.match(regex) != null;
}

function hasNumber(string) {
    var regex= new RegExp('[0-9]');
    return string.match(regex) != null;
}

function hasSpecialChar(string) {
    return /[\s~`!@#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?()\._]/g.test(string);
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}

function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if(!dateString.match(regEx)) return false;  // Invalid format
    var d = new Date(dateString);
    var dNum = d.getTime();
    if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0,10) === dateString;
}